module.exports = __webpack_public_path__ + "img/bg-5.8385c6dd.jpg";